import { useEffect } from "react";

const DEFAULT_TITLE = "Okeydaş · Arkadaşlarla Okey";
const DEFAULT_DESC =
  "Arkadaşlarınla Klasik ve 101 Okey oyna, fiziksel masalarının skorlarını otomatik tut.";

/**
 * Sayfa başlığı + meta description'ı çalışma sırasında güncelleyen küçük yardımcı.
 * SSR yok — CSR'de tarayıcı sekmesi ve paylaşıldığında OG önizlemesi için yeter.
 */
export function useSEO({ title, description } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    const prevDesc = document.querySelector('meta[name="description"]');
    const prevDescContent = prevDesc?.getAttribute("content");
    const prevOgTitle = document.querySelector('meta[property="og:title"]');
    const prevOgTitleContent = prevOgTitle?.getAttribute("content");
    const prevOgDesc = document.querySelector('meta[property="og:description"]');
    const prevOgDescContent = prevOgDesc?.getAttribute("content");

    const t = title ? `${title} · Okeydaş` : DEFAULT_TITLE;
    const d = description || DEFAULT_DESC;

    document.title = t;
    if (prevDesc) prevDesc.setAttribute("content", d);
    if (prevOgTitle) prevOgTitle.setAttribute("content", t);
    if (prevOgDesc) prevOgDesc.setAttribute("content", d);

    return () => {
      document.title = prevTitle;
      if (prevDesc && prevDescContent != null) prevDesc.setAttribute("content", prevDescContent);
      if (prevOgTitle && prevOgTitleContent != null) prevOgTitle.setAttribute("content", prevOgTitleContent);
      if (prevOgDesc && prevOgDescContent != null) prevOgDesc.setAttribute("content", prevOgDescContent);
    };
  }, [title, description]);
}
